/* Produktgalerie v24-a: ohne externe Abhängigkeiten, mit nativer Dialog-Semantik. */
(function () {
  'use strict';

  function initialiseGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;

    var openButton = gallery.querySelector('[data-gallery-open]');
    var mainImage = openButton ? openButton.querySelector('img') : null;
    var mainCounter = gallery.querySelector('[data-gallery-main-counter]');
    var dialog = gallery.querySelector('[data-gallery-dialog]');
    var dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
    var dialogCounter = gallery.querySelector('[data-gallery-dialog-counter]');
    var closeButton = gallery.querySelector('[data-gallery-close]');
    var previousButton = gallery.querySelector('[data-gallery-prev]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

    if (!openButton || !mainImage || !dialog || !dialogImage || !closeButton) return;

    /* 1.6.8 — drei Ladefehler dieser Galerie, alle am echten Storefront belegt:
       1. Das erste 2000px-Bild lud bereits im GESCHLOSSENEN Dialog.
       2. Ein Daumenklick setzte die 2000px-Quelle direkt als Hauptbild und
          entfernte srcset/sizes — daher die Verzoegerung beim ersten Klick.
       3. Nach Blaettern im Dialog stimmte das Hauptbild nicht mehr mit dem
          Zaehler ueberein.
       Jetzt: Das Hauptbild bleibt responsiv (srcset + sizes aus dem Liquid),
       der Dialog laedt die volle Aufloesung erst, wenn er wirklich offen ist,
       und Haupt wie Dialog bleiben immer im selben Zustand. Beruehrt ein
       Finger oder der Fokus einen Daumen, waermt der Browser das Zielbild
       schon einmal vor. */
    var mainSizes = mainImage.getAttribute('sizes') || '(min-width: 900px) 58vw, 100vw';

    /* 1.6.14 Bildbuehne: jeder Wechsel zieht Buehnenverhaeltnis und das
       weichgezeichnete Grund-Duplikat mit — Haupt und Lichtkasten getrennt. */
    var stage = gallery.querySelector('[data-gallery-stage]');
    var mainBackdrop = gallery.querySelector('[data-gallery-backdrop]');
    var dialogBackdrop = gallery.querySelector('[data-gallery-dialog-backdrop]');

    var items = thumbnails.map(function (thumbnail) {
      return {
        id: thumbnail.dataset.galleryImageId,
        source: thumbnail.dataset.gallerySrc,
        sourceSet: thumbnail.dataset.gallerySrcset || '',
        full: thumbnail.dataset.galleryFull || thumbnail.dataset.gallerySrc,
        backdrop: thumbnail.dataset.galleryBackdropSrc || '',
        ratio: parseFloat(thumbnail.dataset.galleryRatio) || 0,
        alt: thumbnail.dataset.galleryAlt || '',
        thumbnail: thumbnail
      };
    });

    if (!items.length) {
      items = [{
        source: dialogImage.currentSrc || dialogImage.src,
        sourceSet: '',
        full: dialogImage.dataset.galleryFull || dialogImage.currentSrc || dialogImage.src,
        backdrop: mainBackdrop ? mainBackdrop.getAttribute('src') : '',
        ratio: 0,
        alt: dialogImage.alt,
        thumbnail: null
      }];
    }

    var initialId = gallery.dataset.galleryInitialId;
    var activeIndex = items.findIndex(function (item) { return item.id === initialId; });
    if (activeIndex < 0) activeIndex = 0;
    var opener = null;

    function normalizedIndex(index) {
      return (index + items.length) % items.length;
    }

    function labelFor(index) {
      return 'Ansicht ' + (index + 1) + ' von ' + items.length;
    }

    function applyMain(item) {
      if (item.sourceSet) {
        mainImage.setAttribute('srcset', item.sourceSet);
        mainImage.setAttribute('sizes', mainSizes);
      }
      mainImage.src = item.source;
      mainImage.alt = item.alt;
      if (stage && item.ratio > 0) stage.style.setProperty('--bild-verhaeltnis', String(item.ratio));
      if (mainBackdrop && item.backdrop) mainBackdrop.src = item.backdrop;
    }

    function applyDialog(item) {
      dialogImage.src = item.full || item.source;
      dialogImage.alt = item.alt;
      if (dialogBackdrop && item.backdrop) dialogBackdrop.src = item.backdrop;
    }

    function warm(item) {
      var probe = new Image();
      if (item.sourceSet) { probe.sizes = mainSizes; probe.srcset = item.sourceSet; }
      probe.src = item.source;
    }

    function select(index, updateMainImage) {
      activeIndex = normalizedIndex(index);
      var item = items[activeIndex];
      var countLabel = (activeIndex + 1) + ' von ' + items.length;

      if (updateMainImage !== false) applyMain(item);
      if (dialog.open) applyDialog(item);

      openButton.setAttribute('aria-label', 'Bild vergrößern: ' + labelFor(activeIndex));
      if (mainCounter) mainCounter.textContent = countLabel;
      if (dialogCounter) dialogCounter.textContent = countLabel;

      items.forEach(function (entry, itemIndex) {
        if (!entry.thumbnail) return;
        if (itemIndex === activeIndex) entry.thumbnail.setAttribute('aria-current', 'true');
        else entry.thumbnail.removeAttribute('aria-current');
      });
    }

    thumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        select(index, true);
      });
      thumbnail.addEventListener('pointerenter', function () { warm(items[index]); });
      thumbnail.addEventListener('focus', function () { warm(items[index]); });
    });

    openButton.addEventListener('click', function () {
      opener = openButton;
      applyDialog(items[activeIndex]);
      dialog.showModal();
      closeButton.focus();
    });

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        select(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        select(activeIndex + 1);
      });
    }

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        select(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        select(activeIndex + 1);
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      if (opener && document.contains(opener)) opener.focus();
    });

    select(activeIndex, false);
    gallery.dataset.galleryReady = 'true';
  }

  function initialiseAll() {
    document.querySelectorAll('[data-product-gallery]').forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-gallery]').forEach(initialiseGallery);
  });
})();
